module.exports = __webpack_public_path__ + "de57294358905f890d52e397d62bc422.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-11.png
// module id = 1659
// module chunks = 0